import { StockAccuracyItem } from '../../../../../hooks';

type AggregateStockAccuracyData = {
  stockAccuracyPercentage: number;
  positiveDifference: number;
  negativeDifference: number;
  openOrderQuantity: number;
  date?: string;
};

const calculateAggregate = (accuracyDetails: StockAccuracyItem[], key: keyof StockAccuracyItem): number =>
  accuracyDetails.reduce((sum, item) => sum + (item[key] as number), 0);

export const getAggregateStockAccuracyData = (
  accuracyDetails: StockAccuracyItem[],
): AggregateStockAccuracyData => {
  const aggregateTotalStockCount = calculateAggregate(accuracyDetails, 'totalStockCount');
  const aggregateTotalPositivePieces = calculateAggregate(accuracyDetails, 'positivePieces');
  const aggregateTotalNegativePieces = calculateAggregate(accuracyDetails, 'negativePieces');
  const aggregateTotalOpenOrders = calculateAggregate(accuracyDetails, 'openOrderQuantity');

  const stockAccuracyPercentage =
    aggregateTotalStockCount === 0
      ? 0
      : ((aggregateTotalStockCount - (aggregateTotalPositivePieces + aggregateTotalNegativePieces)) /
          aggregateTotalStockCount) *
        100;

  const positiveDifference =
    aggregateTotalStockCount === 0 ? 0 : (aggregateTotalPositivePieces / aggregateTotalStockCount) * 100;

  const negativeDifference =
    aggregateTotalStockCount === 0 ? 0 : (aggregateTotalNegativePieces / aggregateTotalStockCount) * 100;

  const openOrderQuantity =
    aggregateTotalStockCount === 0 ? 0 : (aggregateTotalOpenOrders / aggregateTotalStockCount) * 100;

  const data: AggregateStockAccuracyData = {
    stockAccuracyPercentage,
    positiveDifference,
    negativeDifference,
    openOrderQuantity,
  };

  if (accuracyDetails[0]?.date) {
    data.date = accuracyDetails[0].date;
  }

  return data;
};
